export default __webpack_public_path__ + "static/media/5_Rooms.92f612d8.png";